export default state => state.savedItems.displayableItemCount;
